<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        <h4 class="text-primary">การติดตามงาน {{year_S.yearDesc}}</h4>
                    </div>
                    <div class="col">
                        <mat-form-field appearance="fill" style="text-align:center">
                            <mat-label>กรุณาเลือกปี </mat-label>
                            <mat-select disableRipple required [(ngModel)]="year_S" (selectionChange)="Loadkpiall()"
                                [disabled]="loader[0]" style="text-align:center">
                                <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
                                <mat-option *ngFor="let item of year_L" [value]="item">{{item.yearDesc}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field appearance="fill" style="text-align:center; max-width: 220px;"
                            *ngIf="data_list.length > 0">
                            <mat-label>เลือก นสส/โซน/ส่วน</mat-label>
                            <mat-select disableRipple required (selectionChange)="createChart($event.value)"
                                style="text-align:center">
                                <mat-option *ngFor="let item of data_list" [value]="item">
                                    {{item.supname}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col text-right">
                        <button type="button" class="btn btn-tool" (click)="Loadkpiall();">
                            <i class="fas fa-sync"></i>
                        </button>
                        <!--<button type="button" class="btn btn-tool" (click)="ExportExcel();">
                        <i class="fas fa-file-excel"></i>
                    </button>-->
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="loader[0]"></mat-progress-bar>

            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-8" *ngIf="chartOptions_area">
                        <div echarts [options]="chartOptions_area" class="chart-container"></div>
                    </div>
                    <div class="col-md-4" *ngIf="chartOptions_crop_loss">
                        <div echarts [options]="chartOptions_crop_loss" class="chart-container"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6" *ngIf="chartOptions_Assess">
                        <div echarts [options]="chartOptions_Assess" class="chart-container"></div>
                    </div>
                    <div class="col-md-6" *ngIf="chartOptions_yield">
                        <div echarts [options]="chartOptions_yield" class="chart-container"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" *ngIf="chartOptions_aaa">
                        <div echarts [options]="chartOptions_aaa" class="chart-container2"></div>
                    </div>
                    <!--<div class="col-md-6" *ngIf="chartOptions_aaa_m">
                    <div echarts [options]="chartOptions_aaa_m" class="chart-container"></div>
                </div>-->
                </div>
                <div class="row">
                    <div class="col-6" *ngIf="chartOptions_factors">
                        <div echarts [options]="chartOptions_factors" class="chart-container"></div>
                    </div>
                    <div class="col-6" *ngIf="chartOptions_factors2">
                        <div echarts [options]="chartOptions_factors2" class="chart-container"></div>
                    </div>
                </div>
            </div>
            <div class="card-body table-responsive p-2" style="height: 600px">
                <table class="table table-sm table-head-fixed table-bordered border-primary">
                    <thead>
                        <tr style="text-align:center">
                            <th class="no-print">เลือก</th>
                            <th>ส่วน</th>
                            <th>โซน</th>
                            <th>ชื่อ-นามสกุล</th>

                            <th>พื้นที่รวม</th>

                            <th>เป้าหมายER</th>
                            <th>พื้นที่ER</th>
                            <th>พื้นที่ER_Y</th>

                            <th>เป้าหมายERO</th>
                            <th>พื้นที่ERO</th>
                            <th>พื้นที่ERO_Y</th>

                            <th>เป้าหมายST</th>
                            <th>พื้นที่ST</th>
                            <th>พื้นที่ST_Y</th>

                            <th>จำนวนแปลง</th>
                            <th>แปลงAAA</th>
                            <th>%AAA</th>

                            <th>รวมอินทรีย์(พื้นที่)</th>
                            <th>รวมเคมี(กระสอบ)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let dt of data_list;" style="text-align:center" [ngClass]="{'table-danger under' : dt.partcode == 'BRD' 
                                ,'table-success under' : dt.supzone == 'sum' 
                                ,'table-secondary under' : dt.supcode == 'sum'}">
                            <td class="no-print">
                                <button mat-icon-button (click)="createChart(dt)" color="primary">
                                    <mat-icon>insert_chart</mat-icon>
                                </button>

                            </td>
                            <td>{{dt.partcode}}</td>
                            <td>{{dt.supzone}}</td>
                            <td style="text-align:left">{{dt.supname}}</td>

                            <td>{{dt.landvalue|number:'1.2-2'}}</td>

                            <td>{{dt.target_er|number:'1.2-2'}}</td>
                            <td>{{dt.landvalue_er|number:'1.2-2'}}</td>
                            <td>{{dt.landvalue_erY|number:'1.2-2'}}</td>

                            <td>{{dt.target_ero|number:'1.2-2'}}</td>
                            <td>{{dt.landvalue_ero|number:'1.2-2'}}</td>
                            <td>{{dt.landvalue_eroY|number:'1.2-2'}}</td>

                            <td>{{dt.target_st|number:'1.2-2'}}</td>
                            <td>{{dt.landvalue_st|number:'1.2-2'}}</td>
                            <td>{{dt.landvalue_stY|number:'1.2-2'}}</td>

                            <td>{{dt.cnt|number}}</td>
                            <td>{{dt.cnt_aa|number}}</td>
                            <td>{{dt.pc_aa|number:'1.2-2'}}%</td>

                            <td>{{dt.sum_organic|number}}</td>
                            <td>{{dt.sum_chemical|number}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>